import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { styles } from '../ticketDetail.styles';

const SidebarSection: FC<{
  children?: ReactNode;
}> = ({ children }) => <Box sx={styles.sidebarSection}>{children}</Box>;

export default SidebarSection;
